



































import { Component, Vue } from "vue-property-decorator";
import { f7ready } from "framework7-vue";
import Aufgaben from "@/views/Aufgaben.vue";
import AufgabenSchueler from "@/views/AufgabenSchueler.vue";
import Aufgabe from "@/views/Aufgabe.vue";
import Api from "@/Api";

@Component
export default class App extends Vue {
  f7params = {
    name: "Aufgaben",
    id: "de.suetti.it",
    routes: [
      {
        path: "/",
        component: Aufgaben
      },
      {
        path: "/aufgaben/:id/schueler",
        component: AufgabenSchueler,
        options: {
          aufgabe: { id: 123 }
        }
      },
      {
        path: "/aufgaben/:id/:schueler?",
        component: Aufgabe
      }
    ],
    dialog: {
      buttonCancel: "Abbrechen"
    },
    touch: {
      tapHold: true,
      tapHoldDelay: 1800
    }
  };
  code = "";
  loginScreenOpened = true;

  created() {
    f7ready(() => {
      const code = localStorage.getItem("code");
      this.loginScreenOpened = true;
      if (code) this.loginScreenOpened = false;
      (this.$f7 as any).on("logout", () => {
        if (!localStorage.getItem("code")) return;
        (this.$f7 as any).dialog.confirm("Wirklich abmelden?", "Logout", () => {
          Api.post("/logout").then(() => {
            localStorage.removeItem("code");
            localStorage.removeItem("userId");
            localStorage.removeItem("role");
            localStorage.removeItem("username");
            this.loginScreenOpened = true;
          });
        });
      });
    });
  }

  login() {
    Api.post("/login", { code: this.code }).then(r => {
      if (r.data.success) {
        localStorage.setItem("code", this.code);
        localStorage.setItem("userId", r.data.id);
        localStorage.setItem("role", r.data.role);
        localStorage.setItem("username", r.data.name);
        this.loginScreenOpened = false;
        this.code = "";
        (this.$f7 as any).emit("login");
      } else {
        (this.$f7 as any).dialog.alert("Zugangscode ist falsch", "Login");
      }
    });
  }
}
